import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* updateLookbookOrderItem({ payload: {  id, orderId, itemId, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.orders.items.update, pathParams: { id, orderId, itemId }, data: values });

    onSuccess && onSuccess();
    yield put(actions.updateLookbookOrderItemDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.updateLookbookOrderItemFailed,
      handledErrors,
      endpoint: api.lookbooks.orders.items.update.url
    });
  }
}

export const updateLookbookOrderItemSaga = takeEvery(types.UPDATE_LOOKBOOK_ORDER_ITEM_REQUEST, updateLookbookOrderItem);